/**
 * round11/portal-create-lead — the builder's OWN live designer, as a
 * homeowner sees it on the builder's website.
 *
 * This is deliberately NOT `embedMessaging.ts`'s `buildEmbedUrl()`. That
 * helper always adds `preview=1`, because it exists for the Portal's iframe
 * mounts (read-only preview and live edit), and `preview=1` makes the embed
 * mount its PortalPreview surface — a viewer that waits for a design to be
 * pushed in over postMessage and never shows the homeowner's start modal or
 * tools. For a link a builder clicks to open their designer in a new tab,
 * the homeowner URL is the plain `?builder=<tenantId>` — exactly what their
 * pasted iframe loads (see DockPro-Backend docs/CONCIERGE_ONBOARDING.md,
 * step 4b). The origin still comes from `getEmbedOrigin()` so there is one
 * source of truth for which embed this build talks to.
 *
 * Returns null when the build has no embed configured (VITE_EMBED_URL
 * unset) — callers simply do not offer the link.
 */
import { getEmbedOrigin } from "./embedMessaging";

export function homeownerDesignerUrl(tenantId: string): string | null {
  if (!tenantId) return null;
  try {
    const url = new URL(getEmbedOrigin());
    url.pathname = "/";
    url.search = "";
    url.searchParams.set("builder", tenantId);
    return url.toString();
  } catch {
    return null;
  }
}
